"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const html2canvas_1 = __importDefault(require("html2canvas"));
const trans_1 = require("@common/tsutils/trans");
let ModalExportMapReport = class ModalExportMapReport extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.currentExt = '.png';
        this.isLoading = false;
        this.isDownloadFile = false;
    }
    get toastTitle() {
        return (0, trans_1.trans)('tracking.modal_export.done_1') + ' ' + (0, trans_1.trans)('tracking.modal_export.done_2');
    }
    dismissModal() {
        this.$emit('dismissModal');
    }
    downloadkml() {
        this.isLoading = true;
        this.isDownloadFile = false;
        this.$emit('currentExt', this.currentExt);
        // TODO: improve remove timeout
        setTimeout(() => {
            this.isLoading = false;
            this.isDownloadFile = true;
        }, 500);
    }
    downloadImage() {
        const divScreenshot = document.getElementById(`${this.idScreenshot}`);
        (0, html2canvas_1.default)(divScreenshot).then((canvas) => {
            const ext = this.currentExt.toLowerCase();
            const image = canvas.toDataURL(`image/${ext}`);
            const link = document.createElement('a');
            link.href = image;
            link.download = `${this.fileName || '###'}${ext}`;
            link.click();
        });
        this.isLoading = false;
        this.isDownloadFile = true;
        this.$emit('mapScreenshot', false);
    }
    modelEmitExt(currentExt) {
        this.currentExt = currentExt;
    }
    async download() {
        this.isLoading = true;
        this.isDownloadFile = false;
        this.$emit('mapScreenshot', true);
        this.$emit('capture');
        if (this.currentExt.includes('kml')) {
            this.downloadkml();
        }
        else {
            this.downloadImage();
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], ModalExportMapReport.prototype, "fileName", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], ModalExportMapReport.prototype, "idScreenshot", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], ModalExportMapReport.prototype, "optionsSelect", void 0);
ModalExportMapReport = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Modal: bmk_ui_framework_1.Modal,
            Loading: bmk_ui_framework_1.Loading,
            Button: bmk_ui_framework_1.Button,
            PinIcon: bmk_ui_framework_1.PinIcon,
            SelectField: bmk_ui_framework_1.SelectField,
            Select: bmk_ui_framework_1.Select,
            Toasts: bmk_ui_framework_1.Toasts,
            CheckAloneIcon: bmk_ui_framework_1.CheckAloneIcon,
        },
    })
], ModalExportMapReport);
exports.default = ModalExportMapReport;
